<template>
  <div class="w-full h-full overflow-x-hidden">
    <Navbar />
    <main>
      <slot />
    </main>
    <Footer />
  </div>
</template>

<script setup lang="ts">
// import Navbar from '../layout/Navbar.vue'
import Navbar from '../organisms/common/navbar/index.vue'
import Footer from '../layout/Footer.vue'
</script>

<style scoped>
/* Styles additionnels si nécessaire */
</style>
